import React, { createContext, useContext, ReactNode } from 'react'
import { BlockEngine } from './BlockEngine'

type BlockEngineContextType = {
    blockEngine: BlockEngine
}

const BlockEngineContext = createContext<BlockEngineContextType | undefined>(undefined)

export const useBlockEngine = (): BlockEngineContextType => {
    const context = useContext(BlockEngineContext)
    if (!context) {
        throw new Error('useBlockEngine must be used within BlockEngineProvider')
    }
    return context
}

export const BlockEngineProvider: React.FC<{
    blockEngine: BlockEngine
    children: ReactNode
}> = ({ blockEngine, children }) => {
    return (
        <BlockEngineContext.Provider value={{ blockEngine }}>
            {children}
        </BlockEngineContext.Provider>
    )
}
